import { AdvancedDisclosure } from '@/components/common'

export function CollapsibleFieldGroup({ title, children }) {
  return (
    <AdvancedDisclosure label={title}>{children}</AdvancedDisclosure>
  )
}
